module.exports = __webpack_public_path__ + "static/media/logo.2f800be3.png";